import React from 'react';
import { Faq } from './Faq';
import { FinalClose } from './FinalClose';
import { Footer } from './Footer';
import { Guarantee } from './Guarantee';
import { NextCollection } from './NextCollection';
interface LateContentProps {
  onCta: () => void;
}

/** Lower-priority conversion content loaded only as visitors approach it. */
export function LateContent({
  onCta
}: LateContentProps) {
  return <>
      <NextCollection onCta={onCta} data-id="element-132" data-mp="2ibhlyzat90pe" />
      <Guarantee data-id="element-133" data-mp="2icj6rvhmp1kb" />
      <Faq data-id="element-134" data-mp="2ie41pm7uumip" />
      <FinalClose onCta={onCta} data-id="element-135" data-mp="2dd6darw94w8r" />
      <Footer data-id="element-136" data-mp="2de7wjjnf8p1k" />
    </>;
}